<template>
  <v-dialog v-model="show" persistent max-width="650px" scrollable>
    <v-card >
      <v-toolbar color="#CFDDE6" dark height="32px">
        <span>{{ header }}</span>
        <v-spacer></v-spacer>
        <CloseIcon  @click="close" :small="true" />
      </v-toolbar>
      <v-card-text class="pa-0" style="max-height: 500px;">
        <json-viewer
          :value="jsonData"
          :expand-depth="5"
          copyable
        ></json-viewer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import JsonViewer from "vue-json-viewer";

export default {
  name: "JsonViewerDialog",
  components: { JsonViewer },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    jsonData: {
      type: Object,
      default: () => {},
    },
    header:{
      type:String,
      default:()=> {
        return "Activity Details";
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
  methods: {
    close,
  },
};

function close() {
  this.$emit("input", false);
}
</script>

<style scoped>
.v-toolbar /deep/ .v-toolbar__content {
  color: var(--v-darkCharcoal-base);
  font-family: "Noto Sans JP";
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
}
::v-deep .v-card {
  display: flex !important;
  flex-direction: column;
}

::v-deep .v-card__text {
  flex-grow: 1;
  overflow: auto;
}
</style>